// ✅ index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./App.css";
import { BrowserRouter } from "react-router-dom"; // ✅ Router keep karna hai

import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      {/* ✅ Wrap App with Router */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
